import request from './index'

export function getCategoryList(params) {
  return request.get('/category/list', { params })
}

export function getAllCategories() {
  return request.get('/category/all')
}

export function getCategoryById(id) {
  return request.get(`/category/${id}`)
}

export function createCategory(data) {
  return request.post('/category', data)
}

export function updateCategory(id, data) {
  return request.put(`/category/${id}`, data)
}

export function deleteCategory(id) {
  return request.delete(`/category/${id}`)
}
